module.exports = __webpack_public_path__ + "static/media/history.bcb495d9.jpg";